export const isExternalLink = (href: string): boolean => {
  return /^https?|tel:|mailto:/i.test(href)
}
